import React,  { useState } from 'react'
import { Link, useParams } from "react-router-dom"
import car_data from "../Data/car_data.json"
import carfocus_img from "../Data/sample_images/bmw_x6_1_new.png"
import { BsStarFill, BsStarHalf, BsStar, BsFillFuelPumpFill } from "react-icons/bs"
import { AiFillCar } from "react-icons/ai"
import { GiCarDoor } from "react-icons/gi"
import { FaCarSide, FaTachometerAlt } from "react-icons/fa"
import { MdLocationPin } from "react-icons/md"
import { HiCog } from "react-icons/hi"
import { TbEngine } from "react-icons/tb"

const CarFocus = () => {
    // useParams to import id
    const { id } = useParams()

    // variable to allow useParams to refer to correct car
    const starRating = car_data[id].avg_rating

    // Declaring states
    const [activeTab, setActiveTab] = useState("description")
    
    
    // Creating a function that displays the average star rating for each car
    const carRating = [...Array(5)].map((star, index) => {
        if ( starRating > index + 1 ) {
            return <BsStarFill/>
        }
        else if ((index + 1) % starRating < 1 && (starRating - Math.floor(starRating) >= 0.5)) {
            return <BsStarHalf/>
        }
        else if ( starRating < index + 1 ){
            return <BsStar/>
        }
    })

  return (
    <>
        <section id={id} className='carfocus'>
            <div className="container carfocus-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Rent A Car</h1>
                <div className="carfocus-box">
                    <div className="carfocus-img-container">
                        <img src={car_data[id].img} alt="car"/>
                    </div>
                    <div className="carfocus-info-container">
                        <h2 className="carfocus-title">{`${car_data[id].make} ${car_data[id].model} (${car_data[id].year})`}</h2>
                        <div className='carfocus-subtitle'>
                            <h4 className="carfocus-price">£94 per day</h4>
                            <span className="carfocus-rating">
                                <span className="carfocus-stars">
                                    {carRating}
                                </span>
                                <span className="carfocus-rating-amount">
                                    {`(${car_data[id].no_of_reviews} Reviews)`}
                                </span>
                            </span>
                        </div>
                        <p className="carfocus-description">{car_data[id].description}</p>
                        <div className="carfocus-data">
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><AiFillCar/></span>
                                <span className="carfocus-text">{car_data[id].make}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><FaCarSide/></span>
                                <span className="carfocus-text">{car_data[id].bodystyle}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><GiCarDoor/></span>
                                <span className="carfocus-text">{car_data[id].doors}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><MdLocationPin/></span>
                                <span className="carfocus-text">GPS Navigation</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><BsFillFuelPumpFill/></span>
                                <span className="carfocus-text">{car_data[id].fuel_type}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><HiCog/></span>
                                <span className="carfocus-text">{car_data[id].transmission}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><TbEngine/></span>
                                <span className="carfocus-text">{car_data[id].tank_size}</span>
                            </span>
                            <span className="carfocus-span">
                                <span className="carfocus-icon"><FaTachometerAlt/></span>
                                <span className="carfocus-text">{car_data[id].mileage} miles</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="carfocus-review-container">
                    <ul className="carfocus-tab">
                        <li className={`carfocus-tab-title ${activeTab == "description" ? "active" : ""}`} onClick={() => setActiveTab("description")}>Description</li>
                        <li className={`carfocus-tab-title ${activeTab == "reviews" ? "active" : ""}`} onClick={() => setActiveTab("reviews")}>Reviews</li>
                    </ul>
                    <div className={`carfocus-description-content ${ activeTab == "reviews" && "hide"}`}>
                        <p className="carfocus-extended-description">Licence and Fees e.g. vehicle tax, first registration fees (£2.90 per day excl VAT for UK mainland and Northern Ireland). Please note, for Jersey Airport (Channel Islands) and Guernsey Airport (Channel Islands), Licence and Fees are charged locally at the desk upon arrival and starts from £1 p/day, dependent on vehicle category.</p>
                    </div>
                    <div className={`carfocus-review-content ${ activeTab == "description" && "hide"}`}>
                        <div className="carfocus-review">
                            <h4 className="carfocus-review-title">Jessica Anston</h4>
                            <p className="carfocus-review-email">jessica12anston@gmail.com</p>
                            <p className="carfocus-review-description">
                            I rented my car long term for about 8 weeks. This car was amazing, no issues .. seamless!
                            </p>
                        </div>
                        <div className="carfocus-review">
                            <h4 className="carfocus-review-title">Martin Gilbert</h4>
                            <p className="carfocus-review-email">mgilbert203@gmail.com</p>
                            <p className="carfocus-review-description">
                            I had to hire several times from this company and I'm pleased to say that I always receive a professional service. Cars have always been clean, low milage & Staff courtesy and polite totally a 5/5
                            </p>
                        </div>
                        <div className="carfocus-review">
                            <h4 className="carfocus-review-title">Jonny Rosh</h4>
                            <p className="carfocus-review-email">roshmeister@gmail.com</p>
                            <p className="carfocus-review-description">
                            From the moment I placed an order to the pick up point everything was handled extremely well. Credit to your company.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default CarFocus

